export default "__VITE_ASSET__CT4ub2M2__"